require('./uiBusinessCard.tpl.html');
const locale = require('../../../../core/app/core.i18n.json');

/*@ngInject*/
const UIBusinessCardDirective = function ($window, $document, $rootScope, $timeout, $state, coreMediator, coreConstant, authorizationConstants, submissionStateMediator, currentSubmissionModel, currentUserModel, submissionStateModel, organizationType) {

    let linkFunction = function ($scope, $elm, $attrs) {

        $scope.businessCardViewModel = {
            i18n: locale
        };
        $scope.isBusinessCardClicked = false;
        $scope.isCardOpenTemporary = true;
        $scope.mayCloseCard = true;
        $scope.isCardHasMouseFocus = false;

        $scope.LEFT_ARROW = 1;
        $scope.RIGHT_ARROW = 2;
        $scope.TOP_ARROW = 3;
        $scope.BOTTOM_ARROW = 4;
        $scope.RIGHT_BOTTOM_ARROW = 5;
        $scope.xPos = -9999;
        $scope.yPos = -9999;
        $scope.cardWidth = 400;
        $scope.showSendEmailLink = true;

        $scope.timeoutList = [];

        $scope.onCardClick = function () {
            $scope.mayCloseCard = false;
            if ($scope.showBusinessCard) {
                $scope.isBusinessCardClicked = true;
                $scope.isCardOpenTemporary = false;
                $rootScope.isBusinessCardFreezed = true;
            }
        };

        $scope.openEmailEditor = function () {
            let userId = $scope.viewModel.id,
                params = {},
                stateName = '';
            if (!_.isNil(currentSubmissionModel.getCurrentSubmission())) {
                $rootScope.$broadcast(coreConstant.event.HANDLE_EMAIL_FROM_BUSINESS_CARD, $scope.submissionId, parseInt(userId));
                /*
                 * UMS-26310
                 * Use the chatMessageId, emailMessageId, or notificationId property
                 * as a query parameter in the "POST /Email/SendNotification" request.
                 * This is step 2a of 6.
                 * The next step is in the EmailResource.sendEmailNotification method.
                 * The previous step is in the function handling SHOW_USER_BUSINESS_CARD below.
                 */
                let options = undefined;
                if ($scope.chatMessageId) {
                    options = { variables: { chatMessageId: $scope.chatMessageId } };
                } else if ($scope.emailMessageId) {
                    options = { variables: { emailMessageId: $scope.emailMessageId } };
                } else if ($scope.notificationId) {
                    options = { variables: { notificationId: $scope.notificationId } };
                }
                coreMediator.sendEmailNotification('notification.sendEmailFromEmailCollaborationTool', /*isCustom=*/true, $scope.submissionId, options);
            } else {
                params = {
                    submissionId: $scope.submissionId
                };
                stateName = 'submission.default';
                currentSubmissionModel.sendMailUserId = parseInt(userId);
                currentSubmissionModel.doCreateDraftEmail = true;
                $state.go(stateName, params, {reload: true});
            }
            cleanData();
        };

        $scope.onCloseButtonClicked = function () {
            cleanData();
        };

        $scope.onMouseEnter = function () {
            $scope.isCardHasMouseFocus = true;
        };

        $scope.onMouseLeave = function () {
            $scope.isCardHasMouseFocus = false;

            $scope.timeoutList.push($timeout(function () {
                if (!$scope.isBusinessCardClicked && $scope.isCardOpenTemporary && $scope.showBusinessCard) {
                    $scope.showBusinessCard = false;
                }
            }, 1000));

        };

        $scope.$on(coreConstant.event.HIDE_BUSINESS_CARD, function () {
            if ($scope.isCardOpenTemporary && !$scope.isCardHasMouseFocus) {
                cleanData();
            }
        });

        $scope.$on(coreConstant.event.SHOW_ORGANIZATION_CARD, function (arg1, event, organizationId) {
            let xPos = event.pageX - event.offsetX;
            let yPos = event.pageY - event.offsetY;
            $scope.isUserCard = false;
            coreMediator.loadOrganizationById(organizationId).then((organizationSummary) => {
                organizationSummary.organizationType = organizationSummary.organizationType === organizationType.AGENCY ? 'AGENCY' : 'CARRIER';
                formatAddress(organizationSummary);
                showBusinessCardContinue(event, organizationSummary, xPos, yPos, true);
            });
        });

        function formatAddress(organizationSummary) {
            let city = organizationSummary.city,
                state = organizationSummary.state,
                postalCode = organizationSummary.postalCode,
                values = [];
            if(!_.isNil(city)){
                values.push(city);
            }
            if(!_.isNil(state)){
                values.push(state);
            }
            if(!_.isNil(postalCode)){
                values.push(postalCode);
            }
            if(!_.isEmpty(values)) {
                organizationSummary.addressLine3 = _.join(values, ', ');
            }
        }

        /*
         * Ignore any error from the coreMediator.loadUserById call
         * in the function handling SHOW_USER_BUSINESS_CARD below.
         * See the function handling HANDLE_ERROR in uiErrorHandler.js.
         */
        $scope.$on(coreConstant.event.HANDLE_ERROR,
                   function(event, payload) {
                       if ($scope.preventDefaultErrorHandling && $scope.preventDefaultErrorHandling.identifier === payload.identifier) {
                           event.preventDefault();
                           $scope.preventDefaultErrorHandling = undef;
                       }
                   });

        $scope.$on(coreConstant.event.SHOW_USER_BUSINESS_CARD, function (arg1, event, usersummary, userid, isGroup, submissionId, hasBusinessCard, notificationId, chatMessageId, emailMessageId) {
            let xPos = event.pageX - event.offsetX;
            let yPos = event.pageY - event.offsetY;
            $scope.isUserCard = true;
            /*
             * UMS-26310
             * Save the chatMessageId, emailMessageId, and notificationId properties
             * so that they can be used in a call to coreMediator.loadUserById.
             * This is step 1 of 6.
             * The next step is either in the openEmailEditor function above
             * or the function handling '$stateChangeStart' in submissionController.js.
             */
            $scope.chatMessageId = chatMessageId;
            $scope.emailMessageId = emailMessageId;
            $scope.notificationId = notificationId;
            if (isGroup) {
                return;
            }

            if (!_.isNil(usersummary)) {
                showBusinessCardContinue(event, JSON.parse(usersummary), xPos, yPos, hasBusinessCard);
            } else {
                if (_.isEmpty(userid) /*system user*/) {
                    coreMediator.loadUserById(userid, submissionId, notificationId, chatMessageId, emailMessageId)
                                .then(function (userProfile) {
                                          showBusinessCardContinue(event, userProfile, xPos, yPos, hasBusinessCard);
                                      },
                                      function (err) {
                                           $scope.preventDefaultErrorHandling = err;
                                      });
                }
            }

            $scope.isGroup = isGroup;
            $scope.submissionId = submissionId;
        });

        $scope.$on('$destroy', function () {
            $document.off('click', handleDocumentClick);

            _.each($scope.timeoutList, function (item) {
                if (item) {
                    $timeout.cancel(item);
                }
            });
        });

        function showBusinessCardContinue(event, dataObject, xPos, yPos, hasBusinessCard) {
            $scope.showBusinessCard = true;
            $scope.xPos = xPos;
            $scope.yPos = yPos;

            if (!_.isNil($(event.target).closest('.userBusinessCard')) && hasBusinessCard) {
                let targetElem = $(event.target).closest('.userBusinessCard'),
                    rect;

                if(_.isNil(targetElem[0])){
                    targetElem = $(event.target).closest('.organizationCard');
                }
                rect =  targetElem[0].getBoundingClientRect();


                if ($window.innerWidth > 768) {
                    if (isBottomDirection()) {
                        $scope.xPos = rect.left + 2;
                        $scope.yPos -= rect.height + 10;
                        setBottomArrow();
                    } else {
                        $scope.xPos = rect.left + rect.width - 20;
                        $scope.yPos = rect.top + rect.height / 2;
                        setLeftArrow();
                    }
                }
            } else {
                if (isBottomDirection()) {
                    if (isRightDirection()) {
                        setRightBottomArrow();
                    } else {
                        setBottomArrow();
                    }
                } else if (isRightDirection()) {
                    setRightArrow();
                } else if (isLeftDirection()) {
                    if (canDisplayWithBottomArrow()) {
                        setBottomArrow();
                    } else {
                        setLeftArrow();
                    }
                } else {
                    setTopArrow();
                }
            }

            $scope.locationStyle = {
                'left': $scope.xPos,
                'top': $scope.yPos
            };
            $scope.viewModel = dataObject;
            $scope.mayCloseCard = false;
            showProfileImage();
        }

        function setBottomArrow() {
            // business card with bottom arrow
            $scope.direction = $scope.BOTTOM_ARROW;
            $scope.xPos -= 45;
            $scope.yPos -= 150;
        }

        function setLeftArrow() {
            // business card with left arrow
            $scope.direction = $scope.LEFT_ARROW;
            $scope.xPos += 35;
            $scope.yPos -= 30;
        }

        function setRightArrow() {
            // business card with right arrow
            $scope.direction = $scope.RIGHT_ARROW;
            $scope.xPos -= ($scope.cardWidth + 15);
            $scope.yPos -= 25;
        }

        function setTopArrow() {
            // business card with top arrow
            $scope.direction = $scope.TOP_ARROW;
            $scope.xPos -= 55;
            $scope.yPos += 40;
        }

        function setRightBottomArrow() {
            // business card with right-bottom arrow
            $scope.direction = $scope.RIGHT_BOTTOM_ARROW;
            $scope.xPos -= ($scope.cardWidth + 15);
            $scope.yPos -= 75;
        }

        function isRightDirection() {
            return $scope.xPos > ($scope.cardWidth + 90);
        }

        function isLeftDirection() {
            return $window.innerWidth > 768 && !isRightDirection();
        }

        function isTopDirection() {
            return $window.innerWidth > 768 && ($window.innerWidth < 970);
        }

        function isBottomDirection() {
            return $window.innerHeight < ($scope.yPos + 200);
        }

        function canDisplayWithBottomArrow() {
            return $scope.yPos > 200;
        }

        function showProfileImage() {
            let sendMailUserId = $scope.viewModel.id;
            $scope.showSendEmailLink = false;
            if ($scope.isUserCard) {
                coreMediator.loadProfileImage(sendMailUserId).then(function (underwriterImage) {
                    $scope.hasAvatar = !!underwriterImage;
                    $scope.underwriterImage = 'data:image/png;base64,' + underwriterImage;
                });
                $scope.showSendEmailLink = true;

                $scope.showSendEmailLink = currentUserModel.hasAuthorization(authorizationConstants.SEND_EMAIL);
                let newSubmission  = submissionStateModel.getNewSubmission();
                if (currentUserModel.getCurrentUser().userId === sendMailUserId || !_.isNil(newSubmission)) {
                    $scope.showSendEmailLink = false;
                }
            }
        }

        function cleanData() {
            $scope.showBusinessCard = false;
            $rootScope.isBusinessCardFreezed = false;
            $scope.isCardHasMouseFocus = false;
            $scope.isBusinessCardClicked = false;
            $scope.isCardOpenTemporary = true;
            $scope.viewModel = {};
            $scope.hasAvatar = false;
            $scope.underwriterImage = null;
        }

        function handleDocumentClick() {
            $scope.$apply(function () {
                if ($scope.mayCloseCard) {
                    cleanData();
                }
                $scope.mayCloseCard = true;
            });
        }

        $document.on('click', handleDocumentClick);
    };

    return {
        restrict: 'AE',
        link: linkFunction,
        templateUrl: '/common/businessCard/uiBusinessCard.tpl.html'
    };
};

angular.module('umCore')
    .directive('uiBusinessCard', UIBusinessCardDirective);
